import { Helmet } from "react-helmet-async";

const SITE = "https://sfxaura.com";

const CONTENT = {
  en: {
    lang: "en",
    ogLocale: "en_US",
    title: "AuraFX — AI Sound Effects Generator | Text to SFX, Music & Voice Over",
    description:
      "Generate cinema-grade sound effects, music and voice overs from a text prompt. Free AI sound generator for film, theater, animation, games and podcasts: AI prompt enhancer, 25+ realistic voices, multi-track mixer, MP3 export. 100% royalty-free.",
    keywords:
      "AI sound effects generator, sound effect generator, text to sound effect, text to sfx, AI sfx, free sound effects, AI music generator, text to music, AI voice over generator, text to speech, AI voice generator, foley generator, auto foley, video to audio, cinematic sound design, sound design tool, sound effects for film, sound effects for theater, sound effects for animation, sound effects for games, sound effects for podcasts, whoosh sound effect, explosion sound effect, rain sound effect, ambient sound generator, royalty free sound effects, royalty free sfx, online sound generator, audio generator AI",
    ogTitle: "AuraFX — Cinema-grade sound effects, music & voice overs from a single prompt",
    ogDescription:
      "Type a prompt — get broadcast-ready audio in seconds. Sound effects, music and AI voice overs for theater, film, animation, games and podcasts.",
  },
  ru: {
    lang: "ru",
    ogLocale: "ru_RU",
    title: "AuraFX — генератор звуковых эффектов, музыки и озвучки на ИИ | Звук из текста",
    description:
      "Создавайте звуковые эффекты, музыку и озвучку кинематографичного качества из текстового промпта. Бесплатный ИИ-генератор звука для кино, театра, мультфильмов, игр и подкастов: AI-улучшение промптов, 25+ реалистичных голосов, многодорожечный микшер, экспорт MP3. Все звуки роялти-фри.",
    keywords:
      "генератор звуков, генератор звуковых эффектов, звуковые эффекты ИИ, звук из текста, нейросеть для звука, генератор SFX, генератор музыки ИИ, музыка из текста, озвучка текста ИИ, генератор голоса, звук для театра, звук для кино, звуки для мультфильмов, звуки для игр, звуки для подкастов, звук взрыва, звук дождя, шум моря, эмбиент звуки, звуковой дизайн, бесплатные звуковые эффекты, роялти фри звуки, озвучка видео ИИ",
    ogTitle: "AuraFX — звуковые эффекты, музыка и озвучка из одного промпта",
    ogDescription:
      "Введите промпт — получите готовый звук за секунды. Звуковые эффекты, музыка и ИИ-озвучка для театра, кино, анимации, игр и подкастов.",
  },
};

export default function Seo({ lang = "en", path = "/" }) {
  const c = CONTENT[lang] || CONTENT.en;
  const canonical = lang === "ru" ? `${SITE}${path}?lang=ru` : `${SITE}${path}`;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{c.title}</title>
      <meta name="description" content={c.description} />
      <meta name="keywords" content={c.keywords} />
      <link rel="canonical" href={canonical} />

      {/* Multilingual alternates */}
      <link rel="alternate" hrefLang="en" href={`${SITE}${path}`} />
      <link rel="alternate" hrefLang="ru" href={`${SITE}${path}?lang=ru`} />
      <link rel="alternate" hrefLang="x-default" href={`${SITE}${path}`} />
    </Helmet>
  );
}

